import api from "../configuration/ApiConfig";
const FormServices = {
  GetFormDesignByCustomerServiceId: (customerServiceId) => {
    const request = api.get(
      `FormDesign/GetFormDesignByCustomerServiceId?customerServiceId=${customerServiceId}`
    );
    return request.then((response) => {
      return response.data;
    });
  },
  GetFormDataByCustomerServiceIdAndFormId: (customerServiceId, formId) => {
    const request = api.get(
      `FormDesign/GetFormDataByCustomerServiceIdAndFormId?customerServiceId=${customerServiceId}&formDesignId=${formId}`
    );
    return request.then((response) => {
      return response.data;
    });
  },
  AddUpdateFormData: (formData) => {
    const request = api.post("FormDesign/AddUpdateFormData", formData);
    return request.then((response) => {
      return response.data;
    });
  },
};
export default FormServices;
